import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getAzureFunctionControls, getReadonlyControl, azureFunctionResourceIdFormat, azureFunctionResourceIdErrorMessage } from './shared-control-metadata';


export const azureFunctionPEMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Web/sites',
    connectionSuffix: 'privateConnections',
    resourceIdValidator: azureFunctionResourceIdFormat,
    groupIdMetadata: {
        sites: {
            linkedServiceType: 'AzureFunction',
            groupId: 'sites',
            iconClass: 'svg-i-100x100-AzureFunction',
            displayName: stringResources.AzureFunctionActivityLabel,
            controls: {
                creationControls: getAzureFunctionControls(),
                readonlyControls: getReadonlyControl(azureFunctionResourceIdFormat, azureFunctionResourceIdErrorMessage)
            }
        }
    }
};
